import Icon from 'veui/components/Icon'
import { IconUserCircle } from 'dls-icons-vue'

Icon.register('user-circle', IconUserCircle)
